import React from "react";

// Shared pale-blue photographic header banner (matches the Buyer Needs style).
// Decorative image is right-anchored and never intercepts clicks; a pale-blue
// gradient keeps the heading readable and acts as the fallback if the image fails.
const B = (name) => `${process.env.PUBLIC_URL || ""}/page-banners/${name}`;

export const PAGE_BANNERS = {
  connections: B("connections.webp"),
  opportunities: B("opportunities.webp"),
  referrals: B("referrals.webp"),
  inquiries: B("inquiries.webp"),
};

export function PageBanner({ image, icon: Icon, title, description, actions, testid }) {
  return (
    <div className="mb-6" data-testid={testid}>
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#EAF4FF] to-[#D6E9FA] border border-[#DCE5EF]">
        {image && (
          <img
            src={image}
            alt=""
            aria-hidden="true"
            loading="eager"
            className="pointer-events-none select-none absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: "right 30%" }}
          />
        )}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#EAF4FF] via-[#EAF4FF]/90 to-[#EAF4FF]/55 sm:via-[#EAF4FF]/85 sm:to-[#EAF4FF]/10" />
        <div className="relative z-10 px-5 sm:px-7 py-6 flex items-center min-h-[150px] sm:min-h-[168px]">
          <div className="max-w-xl">
            <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#0F2C59] flex items-center gap-2">
              {Icon && <Icon className="h-7 w-7 text-[#C79A3B] shrink-0" />}{title}
            </h1>
            {description && <p className="mt-1.5 text-slate-600 text-sm max-w-xl">{description}</p>}
          </div>
        </div>
      </div>
      {actions && <div className="mt-3 flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export default PageBanner;
